const GOOGLE_MAPS_API_KEY = "AIzaSyCoggQM4Ha0ThAvGr1_fbPEo3pA3_PnYk0";

export { GOOGLE_MAPS_API_KEY };
